import { atom } from "jotai"

const editingItemAtom = atom(false)

export default editingItemAtom
